module.exports = __webpack_public_path__ + "static/media/tablet.c94954d0.png";